var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-0 p-0" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.reference === "DDPP"
          ? _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Categoría",
                  disabled: _vm.readOnly,
                  placeholder: "Elija una categoría",
                  name: "category"
                },
                on: { change: _vm.setCategory },
                model: {
                  value: _vm.category,
                  callback: function($$v) {
                    _vm.category = $$v
                  },
                  expression: "category"
                }
              },
              _vm._l(_vm.categoryOptions, function(item) {
                return _c("vs-select-item", {
                  key: item.opcionId,
                  attrs: { value: item.opcionId, text: item.descripcion }
                })
              }),
              1
            )
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 my-2" },
      [
        _vm.reference === "DDPP" && _vm.category
          ? _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Documento",
                  disabled: _vm.readOnly,
                  placeholder: "Elija un documento",
                  name: "document"
                },
                on: { change: _vm.setDocument },
                model: {
                  value: _vm.document,
                  callback: function($$v) {
                    _vm.document = $$v
                  },
                  expression: "document"
                }
              },
              _vm._l(_vm.documentOptions, function(item) {
                return _c("vs-select-item", {
                  key: item.opcionId,
                  attrs: { value: item.opcionId, text: item.descripcion }
                })
              }),
              1
            )
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.reference === "801" || _vm.reference === "SCO"
          ? _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Categoría",
                  disabled: _vm.readOnly,
                  placeholder: "Elija una categoría",
                  name: "purchaseType"
                },
                on: { change: _vm.setPurchaseType },
                model: {
                  value: _vm.purchaseType,
                  callback: function($$v) {
                    _vm.purchaseType = $$v
                  },
                  expression: "purchaseType"
                }
              },
              _vm._l(_vm.purchaseTypeOptions, function(item) {
                return _c("vs-select-item", {
                  key: item.opcionId,
                  attrs: { value: item.valor, text: item.descripcion }
                })
              }),
              1
            )
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.reference === "RD2"
          ? _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de rendición",
                  disabled: _vm.readOnly,
                  placeholder: "Elija un tipo de rendición",
                  name: "reportType"
                },
                on: { change: _vm.setReportType },
                model: {
                  value: _vm.reportType,
                  callback: function($$v) {
                    _vm.reportType = $$v
                  },
                  expression: "reportType"
                }
              },
              _vm._l(_vm.reportTypeOptions, function(item) {
                return _c("vs-select-item", {
                  key: item.opcionId,
                  attrs: { value: item.valor, text: item.descripcion }
                })
              }),
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }